import styled from '@emotion/styled';

import { Card } from '@app/components/Card/Card';
import theme from '@app/styles/theme';

import { LicenseCardVariant } from './LicenseCard.constants';

export type LicenseCardWrapperProps = {
  highlight?: boolean;
  variant?: LicenseCardVariant;
};

const getHighlightBorderColor = (variant?: LicenseCardVariant) => {
  switch (variant) {
    case LicenseCardVariant.Recommendation:
      return theme.colors.acidGreen;
    case LicenseCardVariant.Unqualified:
      return theme.colors.darkOrange;
    default:
      return theme.colors.lightBlue;
  }
};

export const LicenseCardWrapper = styled(Card)<LicenseCardWrapperProps>`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: 0;

  ${({ highlight, variant }) =>
    highlight && `border-color: ${getHighlightBorderColor(variant)};`}

  ${({ variant }) =>
    variant === LicenseCardVariant.Recommendation &&
    `&:hover {
      border-color: ${getHighlightBorderColor(variant)};
    }
    `}

  ${({ variant, theme }) =>
    variant === LicenseCardVariant.Unqualified &&
    `background-color: ${theme.colors.blueishGray};`}

  ${({ variant, theme, highlight }) =>
    variant === LicenseCardVariant.Unqualified &&
    highlight &&
    `background-color: ${theme.colors.lightOrange};
      &:hover {
        border-color: ${getHighlightBorderColor(variant)};
      }
    `}
`;
